import React, { useEffect, useState } from "react";
import { sortBy, groupBy } from "lodash";

import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { ModeCard, VariableCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult } from "@/types";
import { tvOptions } from "@/utils";


interface UsageViewProps {
  scores: InsightResult[];
}

const USAGE_CATEGORIES = ['Applications', 'Devices', 'Networks']

export const UsageView: React.FC<UsageViewProps> = ({ scores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [minMax, setMinMax] = useState<number[]>([0, 1]);

  useEffect(() => {
    const maxScore = Math.max.apply(
      Math,
      scores
        .filter((x) => x.tag_name !== x.tag_category)
        .map((x) => Number(x[scoreType.value as keyof InsightResult])),
    );
    const minScore =
      scoreType.value === "rate"
        ? Math.min.apply(
          Math,
          scores
            .filter((x) => x.tag_name !== x.tag_category)
            .map((x) => Number(x[scoreType.value as keyof InsightResult])),
        )
        : Math.max(1 - (maxScore - 1), 0);

    setMinMax([minScore, maxScore])
  }, [scores, scoreType])

  return (
    <>
      <Grid size={12}>
        <Typography>When do they watch TV?</Typography>
      </Grid>
      <Grid container size={12} spacing={2}>
        {tvOptions.map((option, idx) => (
          <ModeCard
            key={idx}
            title={option.label}
            modes={option.options}
            variables={scores.filter(x => x.tag_category === option.name)}
            score={scoreType.value}
            minValue={0.8}
            maxValue={1.2}
          />
        ))}
      </Grid>

      {Object.entries(groupBy(scores, 'tag_category')).map((category, idx) => (
        USAGE_CATEGORIES.includes(category[0]) && (
          <Grid size={12} key={category[0]}>
            <Stack spacing={1} sx={{ mb: 1 }}>
              <Typography>{`What ${category[0]} do they use?`}</Typography>
              <Grid container size={12} spacing={1.5} maxHeight={280} sx={{ overflowY: 'auto' }}>
                {category[1].map((variable, variableIdx) => (
                  <Grid key={`${category[0]}-${variableIdx}`}>
                    <VariableCard
                      name={variable.tag_name}
                      value={Number(variable[scoreType.value as keyof InsightResult])}
                      score={scoreType.value}
                      showLogo={true}
                      minValue={minMax[0]}
                      maxValue={minMax[1]}
                      width={218}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Grid>
        )
      ))}
    </>
  );
};

export default UsageView;
